import { render } from "./SiteBlacklist.vue?vue&type=template&id=522d523c&scoped=true"
import script from "./SiteBlacklist.vue?vue&type=script&lang=js"
export * from "./SiteBlacklist.vue?vue&type=script&lang=js"

import "./SiteBlacklist.vue?vue&type=style&index=0&id=522d523c&lang=scss&scoped=true"

import exportComponent from "/Users/sherinbloemendaal/projects/spb/pricetiger/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-522d523c"]])

export default __exports__